import { Component, OnInit, AfterViewInit } from '@angular/core';
import { NaviService } from '../../services/navi.service';
import { BasicError } from '../../models/error/error';

import { Thread } from '../../models/thread';
import { Study } from '../../models/study';
import { User } from '../../models/user';
import { MessageService } from '../../services/message.service';
import { ProfileService } from '../../services/profile.service';
declare var $: any;

@Component({
  selector: 'app-hcp-messaging-list',
  templateUrl: './hcp-messaging-list.component.html',
  styleUrls: ['./hcp-messaging-list.component.css']
})
export class HcpMessagingListComponent implements OnInit, AfterViewInit {
  public isEmptyMessages = true;
  public threads = [];
  public threadsData = {};
  public threadDeleteCheck = {};

  public lastUpdateCount = 0;
  public timeout = null;
  public messageURL = 'hcp/messages/';
  public prepareDelete: Thread = null; // Thread to be deleted
  public isDeleted = false;
  public deletionMessage = 'Die Nachricht wurde erfolgreich gelöscht!';
  public currentUser: User = null;

  constructor(private naviService: NaviService, private messageService: MessageService, private profileService: ProfileService) { }

  ngOnInit() {
    this.threads = []
    this.messageService.getAllMessages().subscribe(dd => {
      if (dd instanceof BasicError) {
        console.log('Error occured while reading study');
      } else if (dd instanceof Array) {
        const tmp = this.threads.concat(dd);
        this.threads = [];

        $('#datatable').dataTable().fnDestroy();

        this.threads = tmp;

        for (const thread of this.threads) {
          const stats = {};
          const usrs = thread.getUsers();
          let usrsString = '';
          stats['amountMessages'] = thread.getAmountMessages();

          if (usrs.length > 4) {
            usrsString += usrs[0].getFirstName() + ' ' + usrs[0].getLastName();
            usrsString += ', ' + usrs[1].getFirstName() + ' ' + usrs[1].getLastName();
            usrsString += ', ' + usrs[2].getFirstName() + ' ' + usrs[2].getLastName();
            usrsString += ', ' + usrs[3].getFirstName() + ' ' + usrs[3].getLastName();
            usrsString += ' (+' + (usrs.length - 4) + ' weitere)';
          } else {
            for (const usr of usrs) {
              if (usrsString !== '') { usrsString += ', '; }
              usrsString += usr.getFirstName() + ' ' + usr.getLastName();
            }
          }

          stats['amountUsers'] = usrsString;
          this.threadsData[thread.getId()] = stats;
        }

        if (this.threads.length !== 0) {
          this.isEmptyMessages = false;
        }

        this.profileService.getMyProfile().subscribe(usr => {
          if (usr instanceof BasicError) {
            return;
          }

          this.currentUser = usr;

          for (const t of this.threads) {
            this.checkDelete(t);
          }
        });
      }
    });

    if (this.threads.length === 0) {
      this.isEmptyMessages = true;
    }
  }

  ngAfterViewInit() {
    $(document).ready(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });
  }


  public updateRows() {
    if (this.lastUpdateCount !== this.threads.length) {
      this.lastUpdateCount = this.threads.length;

      if (this.timeout !== null) {
        clearTimeout(this.timeout);
      }

      this.timeout = setTimeout(function () {
        $('#datatable').DataTable({
          'destroy': true,
          'pageLength': 25
        });
      }, 200);
    }
  }

  /**
   * This function refreshes the messages
   */
  public refresh() {
    this.threads = [];
    $('#datatable').dataTable().fnDestroy();
    this.messageService.getAllMessages().subscribe(dd => {
      if (dd instanceof BasicError) {
        console.log('Error occured while reading study');
      } else if (dd instanceof Array) {
        const tmp = this.threads.concat(dd);
        this.threads = [];

        $('#datatable').dataTable().fnDestroy();

        this.threads = tmp;

        for (const thread of this.threads) {
          const stats = {};
          const usrs = thread.getUsers();
          let usrsString = '';
          stats['amountMessages'] = thread.getAmountMessages();

          if (usrs.length > 4) {
            usrsString += usrs[0].getFirstName() + ' ' + usrs[0].getLastName();
            usrsString += ', ' + usrs[1].getFirstName() + ' ' + usrs[1].getLastName();
            usrsString += ', ' + usrs[2].getFirstName() + ' ' + usrs[2].getLastName();
            usrsString += ', ' + usrs[3].getFirstName() + ' ' + usrs[3].getLastName();
            usrsString += ' (+' + (usrs.length - 4) + ' weitere)';
          } else {
            for (const usr of usrs) {
              if (usrsString !== '') { usrsString += ', '; }
              usrsString += usr.getFirstName() + ' ' + usr.getLastName();
            }
          }

          stats['amountUsers'] = usrsString;
          this.threadsData[thread.getId()] = stats;
        }

        if (this.threads.length !== 0) {
          this.isEmptyMessages = false;
        }


      }
    });
  }


  /**
   * Navigate to follow string
   * @param name string to navigate to
   */
  public navigate(name: String): void {
    this.naviService.setCurrentPage(name);
  }

  /**
   * redirects to the message
   * @param id id of thread to be navigated to
   */
  public navigateToMessage(id: Thread) {
    console.log(id);
    const url = this.messageURL + id.getId();
    this.naviService.navigateToUrl(url, 'hcpmessages');
  }

  /**
   * Prepare deleting
   * @param thread thread to be deleted
   */
  public prepareDeleting(thread: Thread) {
    this.isDeleted = false;
    this.prepareDelete = thread;
    $('#ModalDeleteThread').modal('show');
  }

  /**
   * This function finally deletes the message
   */
  public finallyDeleteMessage() {
    if (this.prepareDelete === null) {
      return;
    }

    this.messageService.deleteThread(this.prepareDelete).subscribe(json => {
      if (json instanceof BasicError) {
        console.log('Error occured while deleting');
        console.log(json);
        this.deletionMessage = 'Die Nachricht konnte nicht gelöscht werden. Vermutlich sind Sie nicht der Besitzer dieser Nachricht';
        this.isDeleted = true;
        return;
      }

      // Deleting was successful
      this.refresh();
      this.deletionMessage = 'Die Nachricht wurde erfolgreich gelöscht!';
      this.isDeleted = true;
    });
  }

  /**
   * This function is checking if this message can be deleted by this user
   * @param thread thread the function should check on
   */
  public checkDelete(thread: Thread) {
    if (this.threadDeleteCheck[thread.getId().toString()]) {
      return this.threadDeleteCheck[thread.getId().toString()];
    }

    if (thread.getMessages() !== null && thread.getMessages() !== undefined && thread.getMessages().length !== 0) {
      if (thread.getMessages().length === 0) {
        this.threadDeleteCheck[thread.getId().toString()] = false;
      } else if (thread.getMessages()[0].getAuthor().getID() === this.currentUser.getID()) {
        this.threadDeleteCheck[thread.getId().toString()] = true;
      } else {
        this.threadDeleteCheck[thread.getId().toString()] = false;
      }

      return;
    }

    this.messageService.getThreadDetail(thread.getId()).subscribe(json => {
      if (json instanceof BasicError) {
        this.threadDeleteCheck[thread.getId().toString()] = false;
      } else if (json instanceof Thread) {
        if (json.getMessages().length === 0) {
          this.threadDeleteCheck[thread.getId().toString()] = false;
        } else if (json.getMessages()[0].getAuthor().getID() === this.currentUser.getID()) {
          this.threadDeleteCheck[thread.getId().toString()] = true;
        } else {
          this.threadDeleteCheck[thread.getId().toString()] = false;
        }
      }
    });
  }

}



// WEBPACK FOOTER //
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/components/hcp-messaging-list/hcp-messaging-list.component.ts